import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  return {
    cardNoBorder: {
      border: "none !important",
      borderRadius: "0 !important",
      boxShadow: "none !important"
    },
    cardHeader: {
      paddingLeft: 0,
      paddingRight: 0
    },
    coveredSubheading: {
      marginTop: theme.busbud.spacing(3)
    },
    dialogContent: {
      paddingTop: 0,
      "&:after": {
        paddingBottom: 0
      }
    },
    collapseInnerContent: {
      [theme.busbud.breakpoints.up("sm")]: {
        paddingLeft: theme.busbud.spacing(2),
        paddingRight: theme.busbud.spacing(2)
      }
    },
    lastContent: {
      paddingBottom: theme.busbud.spacing(3)
    },
    requestList: {
      listStyle: "disc",
      paddingLeft: theme.busbud.spacing(4),
      marginTop: theme.busbud.spacing(3)
    },
    mdListItem: {
      display: "inline",
      "& > div,p": {
        display: "inline"
      }
    },
    closeIcon: {
      background: "transparent"
    }
  };
});
